var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    attrs: {
      "id": "error-body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorBody)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-10 flex flex-row flex-wrap gap-4 sm:flex-col sm:gap-10",
    attrs: {
      "id": "error-buttons"
    }
  }, [_vm.tryAgainButton ? _c('button', {
    key: 'try-again-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('clear-error');
      }
    }
  }, [_vm._v("\n\t\t\t\tTry again\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.resetPlaidButton && _vm.canRetryPlaid ? _c('button', {
    key: 'reset-plaid-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('reset-plaid');
      }
    }
  }, [_vm._v("\n\t\t\t\tRelink Plaid\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.newBankButton ? _c('button', {
    key: 'new-bank-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('reset-plaid');
      }
    }
  }, [_vm._v("\n\t\t\t\tTry another bank\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.retryPersonaButton ? _c('button', {
    key: 'retry-persona-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('clear-error');
      }
    }
  }, [_vm._v("\n\t\t\t\tRestart verification\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.policiesButton ? _c('nuxt-link', {
    key: 'policies-button',
    class: _vm.buttonClasses,
    attrs: {
      "to": "/members/cau",
      "tag": "button"
    }
  }, [_vm._v("\n\t\t\t\tTry again\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.devOnlyButton && _vm.isDev ? _c('button', {
    key: 'dev-only-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('clear-error');
      }
    }
  }, [_vm._v("\n\t\t\t\tTry again (dev)\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.loginButton ? _c('nuxt-link', {
    class: _vm.buttonClasses,
    attrs: {
      "to": "/members/login",
      "tag": "button"
    }
  }, [_vm._v("\n\t\t\t\tLog in\n\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('disclosure-footer')], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };